<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">勤怠管理一覧</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="dl()"
        >
          <span class="fal fa-download mr-1"></span>Excel出力
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>検索条件</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-search">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">指定月</div>
                <div class="col-md-5 contCnt input-daterange input-group">
                  <input
                    type="month"
                    class="form-control form-control-sm"
                    style="width: 60%"
                    v-model="domDateMonth"
                  />
                  <input
                    type="button"
                    class="btn-primary form-control form-control-sm"
                    @click="prevMonth()"
                    value="<<"
                  />
                  <input
                    type="button"
                    class="btn-primary form-control form-control-sm"
                    @click="nextMonth()"
                    value=">>"
                  />
                </div>
                <div class="col-md-1 contTitle">社員番号</div>
                <div class="col-md-5 contCnt input-daterange input-group">
                  <div class="input-daterange input-group" id="datepicker-5">
                    <input
                      type="text"
                      class="form-control"
                      name="start"
                      v-model="domStaffNo_start"
                      @keydown.enter="getlist(1)"
                    />
                    <div class="input-group-append input-group-prepend">
                      <span class="input-group-text fs-xl" style="height: 35px"
                        >－</span
                      >
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      name="end"
                      v-model="domStaffNo_end"
                      @keydown.enter="getlist(1)"
                    />
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">氏名</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtUserNm"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="domStaffName"
                    @keydown.enter="getlist(1)"
                  />
                </div>
                <!-- <div class="col-md-1 contTitle">拠点</div>
                <div class="col-md-5 contCnt">
                  <vSelect :options="optionsOp" v-model="domBranch"></vSelect>
                </div> -->
              </div>
              <!-------------------->
              <div class="row">
                <button
                  type="button"
                  class="btn btn-primary waves-effect waves-themed btn-search mx-auto"
                  :disabled="btnDisable"
                  @click="getlist(1)"
                >
                  検索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>条件結果</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-list">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content">
              <!-- good table start -->
              <vue-good-table
                mode="remote"
                v-on:page-change="onPageChange"
                v-on:sort-change="onSortChange"
                :columns="columns"
                :rows="delegate.items"
                :sort-options="{
                  enabled: false,
                }"
                :pagination-options="{
                  perPageDropdownEnabled: false,
                  enabled: true,
                  jumpFirstOrLast: false,
                  nextLabel: '次へ',
                  prevLabel: '前へ',
                  mode: 'pages',
                  ofLabel: '/',
                  pageLabel: '',
                }"
                :totalRows="delegate.pager.maxcount"
              >
                <template #table-row="props">
                  <div
                    v-if="props.column.field == 'btnDet'"
                    class="gtablecell btnDetCell"
                  >
                    <button
                      type="button"
                      class="btn btn-xs btn-block btn-primary waves-effect waves-themed"
                      :disabled="btnDisable"
                      @click="
                        goTo(
                          '/attendanceedit?id=' +
                            props.row.c_staff_id +
                            '&mo=' +
                            domDateMonth,
                          $event
                        )
                      "
                    >
                      詳細
                    </button>
                  </div>
                  <div
                    v-if="props.column.field == 'c_branch_id'"
                    class="gtablecell"
                  >
                    {{
                      optionsOp[props.formattedRow[props.column.field]].label
                    }}
                  </div>
                  <div v-else class="gtablecell">
                    {{ props.formattedRow[props.column.field] }}
                  </div>
                </template>
              </vue-good-table>
              <!-- good table end -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Cl_common } from "@/functions/Cl_common";
import { CONST_LIST_DEFO_COUNT } from "@/constants/constant";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Cl_staff } from "@/functions/Cl_staff";
import { DtoStaffsGetReqImple } from "furukawa-common/src/common/dto/DtoStaffsGetReqImple";
import { DtoStaffsGetResImple } from "furukawa-common/src/common/dto/DtoStaffsGetResImple";

import "vue-good-table-next/dist/vue-good-table-next.css";
import { VueGoodTable } from "vue-good-table-next";
import { Cl_filemaster } from "@/functions/Cl_filemaster";
import { DtoFileMastersGetReqImple } from "furukawa-common/src/common/dto/DtoFileMastersGetReqImple";
import { DtoFileReportsGetReqImple } from "furukawa-common/src/common/dto/DtoFileReportsGetReqImple";
import { Cl_filereport } from "@/functions/Cl_filereport";
import { Cl_outputqueue } from "@/functions/Cl_outputqueue";
import { DtoOutputqueuesGetReqImple } from "furukawa-common/src/common/dto/DtoOutputqueuesGetReqImple";
import { DtoOutputqueuesGetResImple } from "furukawa-common/src/common/dto/DtoOutputqueuesGetResImple";

@Options({
  components: {
    vSelect,
    VueGoodTable,
    Mo_modal_alert,
  },
})
export default class AttendanceList extends Vue {
  /**
   * パフォーマンス問題の解決案としてテスト的に実装中
   * 残課題：グローバルなメソッドとして宣言して、どこからでも呼び出せるようにしたい
   * 　　　　色々なパターンでも問題ないかの検証
   * @param url
   * @param event
   */
  goTo(url: string, event?: MouseEvent) {
    if (event && (event.ctrlKey || event.metaKey)) {
      window.open(url);
    } else {
      this.$router.push(url);
    }
  }
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoStaffsGetResImple();
  domStaffNo_start = "";
  domStaffNo_end = "";
  domStaffName = "";
  domBranch = { code: 0, label: "　" };
  domDateMonth = "";
  //ボタン制御用
  btnDisable = false;

  optionsOp = [
    { code: 0, label: "　" },
    { code: 1, label: "東京" },
  ];
  columns = [
    {
      label: "詳細",
      field: "btnDet",
      thClass: "text-center",
      tdClass: "text-center",
      width: "10%",
    },
    {
      label: "社員番号",
      field: "c_staff_number",
      thClass: "text-center",
      tdClass: "text-center",
    },
    {
      label: "氏名",
      field: "c_staff_name",
    },
    // {
    //   label: "ステータス",
    //   field: "c_branch_id",
    //   thClass: "text-center",
    //   tdClass: "text-center",
    // },
  ];

  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    //日付の初期値入力
    //---------------
    // this.domDateMonth = this.formatDate(new Date());

    const date = new Date();
    const year = date.getFullYear();
    let month: string;
    let cnvYearmonth: string;
    if (21 <= date.getDate()) {
      month = ("00" + (date.getMonth() + 2)).slice(-2);
    } else {
      month = ("00" + (date.getMonth() + 1)).slice(-2);
    }

    cnvYearmonth = year + "-" + month;

    //年跨ぎの処理
    if (month == "13") {
      cnvYearmonth = year + 1 + "-01";
    }

    this.domDateMonth = cnvYearmonth;

    //---------------

    await this.getlist(1);
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * 一覧データを読み込む
   */
  async getlist(currentPage: number) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoStaffsGetReqImple();

      //検索条件設定
      dto.pager.count = CONST_LIST_DEFO_COUNT;
      dto.pager.cursor = currentPage;

      dto.isAttendant = 1;
      dto.staffNo_start = this.domStaffNo_start;
      dto.staffNo_end = this.domStaffNo_end;
      dto.staffName = this.domStaffName;
      if (this.domBranch.code != 0) dto.c_branch_id = this.domBranch.code;

      //API実行
      //-------
      this.delegate = await Cl_staff.getList(dto);
      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      //エラー発生で一覧を初期化
      this.delegate = new DtoStaffsGetResImple();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * ファイルをダウンロードする
   */
  async dl() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoFileReportsGetReqImple();
      dto.type = "AttendanceList";
      dto.staffNo_start = this.domStaffNo_start;
      dto.staffNo_end = this.domStaffNo_end;
      dto.staffName = this.domStaffName;
      dto.attendancemo = this.domDateMonth;

      //API実行
      //-------
      const res = await Cl_filereport.get(dto);

      if (0 == res.outputqueue_code.length) {
        throw new Error("出力失敗");
      }

      Cl_common.logger("res.outputqueue_code");
      Cl_common.logger(res.outputqueue_code);

      let timeLimit = Date.now() + 15 * 60 * 1000; // 15分
      let now = Date.now();
      let dtoOutputReq = new DtoOutputqueuesGetReqImple();
      dtoOutputReq.c_outputqueue_code = res.outputqueue_code;
      let resOutputReq = new DtoOutputqueuesGetResImple();
      resOutputReq = await Cl_outputqueue.get(dtoOutputReq);
      while (now < timeLimit) {
        Cl_common.logger("wait request");
        await new Promise((resolve) => setTimeout(resolve, 10000)); // 10秒待つ

        now = Date.now();

        resOutputReq = await Cl_outputqueue.get(dtoOutputReq);
        //↓社領修正行
        if (resOutputReq.c_outputqueue_flag_end == 1) {
          break;
        }
      }

      //レスポンス処理
      //-------
      Cl_common.logger("resOutputReq");
      Cl_common.logger(resOutputReq);

      //↓社領修正行
      if (resOutputReq.c_outputqueue_flag_success == 1) {
        location.href = resOutputReq.url;
      } else {
        throw new Error("出力失敗");
      }
      //window.open(res.url, "_blank");
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  async moveDet(id: string) {
    //詳細ページに移動
    this.$router.push(
      "/attendanceedit?" + "id=" + id + "&mo=" + this.domDateMonth
    );
  }
  /**
   * ページ更新時の処理
   * @param params
   */
  async onPageChange(params: any) {
    //テーブル更新処理
    await this.getlist(params.currentPage);
  }
  /**
   * ソート変更時の処理
   * @param params
   */
  async onSortChange(params: any) {
    //テーブル更新処理
  }
  /**
   * 月表示をデクリする
   */
  async prevMonth() {
    let date = new Date(this.domDateMonth);
    date.setMonth(date.getMonth() - 1);
    this.domDateMonth = this.formatDate(date);
  }
  /**
   * 月表示をインクリする
   */
  async nextMonth() {
    let date = new Date(this.domDateMonth);
    date.setMonth(date.getMonth() + 1);
    this.domDateMonth = this.formatDate(date);
  }
  /**
   * 日付型の変数をyyyy-MMフォーマットの文字列に変換する
   * @param date
   */
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ("00" + (date.getMonth() + 1)).slice(-2);

    return `${year}-${month}`;
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
</script>
